export { default } from './BottomNavigation';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/BottomNavigation/index.js
// module id = 808
// module chunks = 2